// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { formatAuthoredBy } from "@transformers/names";
import { Row, Col, GSGrid, Text, View } from "@components";
import type { Alert, AlertBespokeRecipient } from "@modules/service/reducer/alerts/types";
import type { HierarchyAssignment } from "@modules/service/types";

type OwnProps = $Exact<{
  data: Alert,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AlertBespokeRecipientsView extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_REF"),
        key: "employeeRef",
        renderCell: ({ row }: { row: AlertBespokeRecipient }) => row.employeeRefPrimary,
      },
      {
        name: this.props.t("ALERT_DETAILS_BESPOKE_RECIPIENTS_EMPLOYEE_NAME"),
        key: "employeeName",
        renderCell: ({ row }: { row: AlertBespokeRecipient }) =>
          formatAuthoredBy({
            firstName: row.firstName,
            lastName: row.lastName,
          }),
      },
      {
        name: this.props.t("ALERT_DETAILS_BESPOKE_WORK_EMAIL_ADDRESS"),
        key: "workEmail",
        renderCell: ({ row }: { row: AlertBespokeRecipient }) => {
          return row.workEmail || "";
        },
      },
      {
        name: this.props.t("Hierarchy"),
        key: "assignmentRules",
        renderCell: ({ row }: { row: AlertBespokeRecipient }) => {
          const val = row.assignmentRules
            ? row.assignmentRules.map((item: HierarchyAssignment) => item.target.label).join(", ")
            : "";
          return (
            <div className={"ellipsis cursor-pointer"} style={{ width: "100px" }} title={val}>
              {val}
            </div>
          );
        },
      },
    ];
  }

  get data() {
    return (this.props.data || {}).bespokeRecipients;
  }

  render() {
    return (
      <View gap={3} className="gs-container">
        <View>
          <Text type="h6" text={this.props.t("ALERT_DETAILS_BESPOKE_RECIPIENTS")} />
        </View>
        <GSGrid
          columns={this.columns}
          rows={this.data}
          noResultsText={this.props.t("NO_BESPOKE_RECIPIENTS_MESSAGE")}
        />
      </View>
    );
  }
}

export default localize()(AlertBespokeRecipientsView);
